import {ApolloLink} from '@apollo/client';

export default function createMissingAnnotationLink() {
  return new ApolloLink(function missingAnnotationLink() {
    throw new Error(
      'Could not detect @rest directive, make sure GraphQL operations are being transpiled',
    );
  });
}
